module.exports = __webpack_public_path__ + "img/mainmenbuttonGREEN5.a12f276e.png";